<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section-container-1">
        <img src="@/assets/heroBg.webp" class="img" />
        <HeroSection
          @scrollToPrice="$emit('scrollToPrice')"
          @scrollNextSection="scrollNextSection"
        />

        <OurIslandsSection
          :isAuth="isAuth"
          :currency="currency"
          :islands="$parent.islands"
        />
        <WhyBuySection />
        <SafeSection />
      </div>
      <div class="section-container-2">
        <WhySection :isAuth="isAuth" />
        <OurPriceSection
          :isAuth="isAuth"
          :currency="currency"
          :products="$parent.products"
        />
        <div class="cta-section">
          <div class="title large weight-900">
            {{ $t("Ready to Begin?") }}
          </div>

          <button
            class="hero-button button secondary"
            @click="$emit('scrollToPrice')"
          >
            <span>{{ $t("BUY NOW") }}</span>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import HeroSection from "../components/HeroSection.vue";
import WhyBuySection from "../components/WhyBuySection.vue";
import SafeSection from "../components/SafeSection.vue";
import OurPriceSection from "../components/OurPriceSection.vue";
import OurIslandsSection from "../components/OurIslandsSection.vue";
import WhySection from "../components/WhySection.vue";

export default {
  name: "Home",
  props: {
    currency: {
      type: String,
    },
    isAuth: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeroSection,
    WhyBuySection,
    SafeSection,
    OurPriceSection,
    OurIslandsSection,
    WhySection,
  },
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    scrollNextSection() {
      document.getElementById("price")?.scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-section {
  padding: 0 16px 220px;
  text-align: center;

  .button {
    max-width: 250px;
    margin: 0 auto;
  }
}

@media screen and (max-width: 768px) {
  .cta-section {
    padding-bottom: 60px;
    .title {
      color: #0b2535;
    }
  }
}
</style>
